export enum FranchiseActionTypes {
    GET_FRANCHISES = '@@franchise/GET_FRANCHISES',
    GET_FRANCHISES_SUCCESS = '@@franchise/GET_FRANCHISES_SUCCESS',
    GET_FRANCHISES_ERROR = '@@franchise/GET_FRANCHISES_ERROR',
    SET_CURRENT_FRANCHISE = '@@franchise/SET_CURRENT_FRANCHISE',
}
